import React from 'react';
import * as styles from './index.module.less';
import { H2 } from '@/components';
import RatioMedia from '@/components/ratio-media';

const HowNottaWork = () => {
  return (
    <div className={styles.wrapper}>
      <div className={styles.inner}>
        <H2 className={styles.title}>Nottaの仕組み</H2>
        <div className={styles.cover_wrapper}>
          <RatioMedia
            media={{
              type: 'image',
              src: 'https://www.notta.ai/pictures/flow-chart-202406271736.png',
              alt: 'Nottaの仕組み',
            }}
            ratio={1721 / 2400}
          />
        </div>
      </div>
    </div>
  );
};
export default HowNottaWork;
